import script from "./PublicationConceptsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicationConceptsTab.vue?vue&type=script&setup=true&lang=js"

import "./PublicationConceptsTab.vue?vue&type=style&index=0&id=5c88f290&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c88f290"]])

export default __exports__